__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-22-1776843069-stable-dev/";